module.exports = __webpack_public_path__ + "static/img/left.71abf24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left.png
// module id = F0Yv
// module chunks = 1